<template>
  <div>
  <Breadcrumbs main="Transaction" title="Standing Orders" />
    <div class="container-fluid" v-if="userAccounts && allBanks && standingFrequency">
      <div class="row">
      <div class="col-xl-3 pr-sm-0 box-col-12">
          <div class="file-sidebar">
            <div class="card">
              <div class="card-body">
                <ul>
                <li>
                <router-link to="/standingOrder/interbank">
                    <div class="btn btn-primary">
                      <feather type="briefcase"></feather>
                      Standing Orders to Other Banks
                    </div>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/standingOrder/local">
                    <div class="btn btn-light">
                      <feather type="database"></feather>
                      Standing Orders to TAJBank
                    </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
            <div v-if="loading" class="loader-12"></div>
              <div class="card-header">
                <h5 style="font-weight: 500">Create Standing Order (Other Banks)</h5>
                <span>Setup a new standing order by completing the form below.</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn">
                <div class="card-body">
                <div v-if="loading" class="loader-12"></div>
                    <form class="theme-form is-validated" id="Submit_Transfer_Form">
                        <!-- Initiate the standing order -->
                        <div id="InitiateTransfer" v-show="step === 1">
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="AccountNumber">Source Account <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <select v-model="form.accountNumber" placeholder="Select From Account *" class="form-select acct-num" data-val-length="The field AccountNumber must be a string with a maximum length of 250." data-val-length-max="250" data-val-required="The AccountNumber field is required." id="AccountNumber" name="AccountNumber" required="required"><option :value="null" disabled>Select From Account *</option>
                                      <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                    </select>
                                    <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="AccountNumber" data-valmsg-replace="true"></span>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="recipentAccount">Recipient Account  <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <input class="form-control" @keypress="isNumber" @paste.prevent maxlength="10" v-model="form.destinationAccountNumber" placeholder="Enter Destination Account" type="text"/>
                                    <p class="pull-right mt-2 ms-2">
                                      <button type="button" class="beneModal" data-toggle="modal" data-target="#exampleModal">
                                        <a data-toggle="modal" data-target="#exampleModal" class="primary-color"><i class="fa fa-users"></i> Select from Beneficiaries</a>
                                    </button>
                                  </p>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="DestinationBankCode">Recipient Bank <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <select @change="setBankCode" class="form-select" name="DestinationBankCode" required="required"><option value="">{{form.destinationBankName? form.destinationBankName: 'Select Recipient Bank *'}}</option>
                                      <option v-for="bank in allBanks" id="destinationBankName" :value="bank.code" :key="bank.id">{{bank.name}}</option>
                                    </select>
                                  </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="accountName">Account Name  <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <input v-model="form.destinationAccountName" class="form-control" readonly placeholder="Account Name" type="text" value="" />
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="Description">Amount <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <input class="form-control" @paste.prevent @change="formatInput" @keypress="isNumber" @keyup="formatNum" v-model="form.amount"  min="0" id="Amount" name="Amount" placeholder="Enter Amount *" required="required" type="text" value="" />
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="location">Frequency <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <select @change="setFrequency" v-model="form.frequency" class="form-select acct-num" required="required"><option :value="null" disabled>Select Frequency *</option>
                                    <option v-for="frequency in standingFrequency" :value="frequency.id" :key="frequency.id">{{frequency.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="mb-3 row">
                              <label class="col-sm-3 col-form-label" for="startDate">Start Date <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <div class="input-group">
                                      <div class="input-group-prepend">
                                          <span class="input-group-text"><i class="feather icon-calendar text-danger"></i></span>
                                          <datepicker placeholder="Start Date" input-class="datepicker-here form-control calendar-input digits" :disabledDates="disabledDates" :format="format" v-model="form.startDate" ></datepicker>
                                      </div>
                                  </div>
                              </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="narration">Narration <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <input class="form-control" name="narration" v-model="form.description" placeholder="Enter Narration" type="text" value="" />
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="occurrence">Number Of Occurrences <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <input class="form-control" @paste.prevent @keypress="isNumber" id="no-paste" @click="removeReadonly" autocomplete="off" name="occurrence" v-model="form.numberOfOccurence" :readonly="form.frequency === '1'" placeholder="Enter Number Of Occurrences" type="text" value="" />
                                    <p class="pull-right mt-2 ms-2">
                                      <button type="button" class="beneModal" @click="generateSchedule">
                                        <a data-toggle="modal" data-target="#scheduleModal" class="primary-color"><i class="fa fa-file"></i> View schedule</a>
                                      </button>
                                    </p>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-sm-12 offset-lg-3 offset-sm-0">
                                  <input class="mb-4" style="background-color: red;" type="checkbox" name="checkbox" value="check" v-model="checked"/> I have read and agree to the <a href="https://digitaltest.tajbank.com/files/StandingInstructionDisclaimer.pdf" target="_blank" class="primary-color">Terms and Conditions</a> &nbsp;<br /><br />
                                    <button type="button" @click="inititateStandingOrder" class="btn btn-round btn-primary mr-1">
                                        <div v-if="loading">
                                          <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                                        </div>
                                        <div v-else>
                                          Proceed<i class="fa fa-angle-right ml-2"></i>
                                        </div>
                                      </button>
                                    <button type="button" @click="resetForm" class="btn btn-outline-danger">Cancel</button>
                                </div>
                            </div>
                        </div>
                        <!-- Verify Account Name and Submit Transfer Request -->
                        <div id="AccountNameVerification" v-show="step === 2">
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                                    <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                                    <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="Token" data-valmsg-replace="true"></span>
                                </div>
                            </div>
                            <br />
                            <div class="mb-3 row">
                                <div class="col-sm-9  offset-lg-3 offset-sm-0">
                                    <button type="button" class="btn btn-primary mr-2" @click="submitStandingOrder">
                                      <div v-if="loading">
                                        <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                      </div>
                                      <div v-else>
                                        Submit <i class="fa fa-check ms-2"></i>
                                      </div>
                                    </button>
                                    <button type="button" class="btn btn-outline-danger" @click="goBackTo">Go Back</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
     <!-- beneficiary list Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title pl-2" id="exampleModalLabel">Select Beneficiary</h5>
            <button type="button" class="close text-dark" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <thead>
                <tr>
                    <th>Beneficiary Details</th>
                </tr>
              </thead>
              <tbody>
              <div v-if="getbeneficiaryList.length >= 1 ">
                <div v-for="beneficiary in getbeneficiaryList" :key="beneficiary.id">
                  <div class="pt-2 px-3">{{beneficiary.accountName ? beneficiary.accountName : 'N/A'}} - {{beneficiary.accountNumber ? beneficiary.accountNumber : 'N/A'}} <span class='bg-light p-1 text-secondary'>{{beneficiary.bankName ? beneficiary.bankName : 'N/A'}}</span> <br>
                  <p style="cursor:pointer" @click="selectBeneficiary(beneficiary.id)" class="text-white mt-2 badge badge-danger"><i class='fa fa-check mb-1'></i> Select</p>
                  <hr v-if="getbeneficiaryList.length > 1"/>
                  </div>
                </div>
                </div>
                <tr v-else class="text-center my-3">No Beneficiary</tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- view schedule modal -->
    <div class="modal fade" id="scheduleModal" tabindex="-1" aria-labelledby="scheduleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title pl-2" id="scheduleModalLabel">Standing Order Schedule</h5>
            <button type="button" class="close text-dark" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table views-table table-striped">
              <tbody>
                <div v-if="scheduleLoader" class="text-center mt-4 text-success">
                  <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                </div>
                <tr v-else class="transaction-table" v-for="res in addStandingOrderArray" :key="res">
                  <td>Due Date:<span class="font-weight-bold"><br>{{res | moment}}</span></td>
                  <td>Amount:<span class="font-weight-bold"><br>NGN{{form.amount}}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="loader-12"></div>
</div>
</template>
<script>
  import { mapState } from 'vuex';
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment';
  import $ from 'jquery';
  import { decrypt } from '@/_services/encryption';
  export default {
    components: {
      Datepicker
    },
    filters: {
      moment: function (date) {
        return moment(date).format('YYYY-MM-DD hh:mm:ss a');
      }
    },
    data:() => ({
      format: 'dd-MM-yyyy',
      // disabledDates: {
      //   to: new Date(),
      // },
      form: {
        accountNumber: null,
        destinationAccountNumber: null,
        destinationAccountName: null,
        destinationBankCode: null,
        destinationBankName: null,
        amount: '0.00',
        description: null,
        frequency: null,
        customNumberOfDays: null,
        numberOfOccurence: null,
        startDate: null,
        transactionPin: null,
        platform: 1,
      },
      step: 1,
      loading: false,
      scheduleLoader: false,
      type: 'password',
      addStandingOrderArray: [],
      checked: false,
    }),
    computed: {
      ...mapState({
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
        allBanks: state => state.beneficiaries.allBanks,
        standingFrequency: state => state.standingOrders.standingInstructionFrequency,
        beneficiaryList: state => state.beneficiaries.beneficiaries,
      }),
      getbeneficiaryList() {
        return this.beneficiaryList.filter(beneficiary => beneficiary.transactionType === 3);
      },
      disabledDates() {
        let result = {};
        if(this.form.frequency === '1' || new Date().getHours() >= 18) {
          result = {
            to: new Date(),
          };
        } else {
          result = {
            to: new Date(Date.now() - 8640000),
          };
        }
        return result;
      },
      sortedSchedule: function () {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.addStandingOrderArray.sort(function (a, b) {
          return new Date(a) - new Date(b);
        });
      },
    },
    async mounted() {
      await this.$store.dispatch('beneficiaries/getAllBanks');
      await this.$store.dispatch('standingOrders/getStandingInstructionFrequency');
      await this.$store.dispatch('beneficiaries/getBeneficiaries');
    },
    methods : {
      isNumber(event) {
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      formatInput(event) {
        this.form.amount = event.target.value;
        const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
        this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
      },
      formatNum(event) {
        if(this.form.amount === '') {
          this.form.amount = '0.00';
        } else {
          this.form.amount = event.target.value;
          const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
          this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
        }
        if(event.key === 'Backspace' || event.key === 'Delete') {
          if(event.target.value.length <= 4) {
            const formatter = new Intl.NumberFormat('en-US');
            this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            if(event.target.value.length < 2) {
              this.form.amount = '0.00';
            }
          } else {
            const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
            this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            return;
          }
        }	
        // if(event.target.value.length === 2)    event.target.value = '0.00';
      },
      setBankCode(event) {
        this.form.destinationBankCode = event.target.value;
        if(this.form.destinationBankCode) {
          this.validateAccountNumber();
        }
        // loop through all banks to get the bank name
        this.allBanks.forEach(bank => {
          if(bank.code === this.form.destinationBankCode) {
            this.form.destinationBankName = bank.name;
          }
        });
      },
      validateAccountNumber() {
        this.loading = true;
        const data = {
          bankCode: this.form.destinationBankCode,
          accountNumber: this.form.destinationAccountNumber,
        };
        this.$store.dispatch('transfers/interbankNameEnquiry', data).then(async (response) => {
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          if (response.status === 200) {
            // set ref id for recipient
            this.form.destinationAccountName = userParseData.accountName;
            this.loading = false;
          }
        }).catch((error) => {
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error'
          });
          this.loading = false;
        });
      },
      setFrequency(event) {
        this.form.startDate = null;
        const frequency = event.target.value;
        this.form.frequency = frequency;
        if(frequency === '1') {
          this.form.numberOfOccurence = frequency;
        } else {
          this.form.numberOfOccurence = '';
        }
      },
      // initiate the add standing order process
      inititateStandingOrder() {
        const { accountNumber, destinationAccountNumber, destinationAccountName, destinationBankCode, amount, frequency, numberOfOccurence, startDate, description } = this.form;
        if(accountNumber === null || description === null || destinationAccountNumber === null || destinationAccountName === null || destinationBankCode === null || amount === null || amount === '0.00' || frequency === null || numberOfOccurence === null || startDate === null) {
          this.$swal({
            title:'Oops...',
            text: 'Please fill all required fields',
            type:'error'
          });
          return false;
        } if(!this.checked) {
          this.$swal({
            title:'Oops...',
            text: 'Please accept the terms and conditions',
            type:'error'
          });
          return false;
        } else {
          this.step++;
        }
      },
      // generate schedule for the standing order
      generateSchedule() {
        if(this.form.frequency === null || this.form.numberOfOccurence === null || this.form.numberOfOccurence === '' || this.form.amount === '0.00' || this.form.startDate === null) {
          $('#scheduleModal').modal('hide');
          this.$swal({
            title:'Oops...',
            text: 'Please fill all required fields',
            type:'error'
          });
          return false;
        } else {
          const data = {
            frequency: parseInt(this.form.frequency),
            numberOfOccurence: parseInt(this.form.numberOfOccurence),
            startDate: moment(this.form.startDate).format('YYYY-MM-DD'),
          };
          // dispatch generate schedule action
          this.scheduleLoader = true;
          this.$store.dispatch('standingOrders/generateSchedule', data).then(async (response) => {
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
              this.addStandingOrderArray = userParseData;
              this.scheduleLoader = false;
            }
          }).catch((error) => {
            $('#scheduleModal').modal('hide');
            this.scheduleLoader = true;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title:'Oops...',
              text: objError.errors[0],
              type:'error'
            }).then(() => {
              $('#scheduleModal').modal('show');
            });
          });
        }
      },
      selectBeneficiary(val) {
        // loop through beneficiary list to get the beneficiary id
        this.getbeneficiaryList.forEach(beneficiary => {
          if (beneficiary.id === val) {
            this.form.destinationAccountNumber = beneficiary.accountNumber;
            this.form.destinationAccountName = beneficiary.accountName;
            this.form.destinationBankName = beneficiary.bankName;
            this.form.destinationBankCode = beneficiary.bankCode;
            $('#exampleModal').modal('hide');
          }
        });
      },
      // show pin
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      goNext() {
        
      },
      submitStandingOrder() {
        if(this.form.transactionPin === null) {
          this.$swal({
            title:'Oops...',
            text: 'Please enter transaction pin',
            type:'error'
          });
          return false;
        }
        this.loading = true;
        const data = {
          accountNumber: this.form.accountNumber,
          destinationAccountNumber: this.form.destinationAccountNumber,
          destinationAccountName: this.form.destinationAccountName,
          destinationBankCode: this.form.destinationBankCode,
          description: this.form.description,
          amount: Number(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
          frequency: parseInt(this.form.frequency),
          numberOfOccurence: parseInt(this.form.numberOfOccurence),
          startDate: moment(this.form.startDate).format('YYYY-MM-DD'),
          transactionPin: this.form.transactionPin,
          customNumberOfDays: parseInt(this.form.numberOfOccurence),
          platform: this.form.platform,
        };
        this.$store.dispatch('standingOrders/submitStandingOrder', data).then((response) => {
          if (response.status === 200) {
            this.loading = false;
            this.$swal({
              title:'Success',
              text: 'Standing order created successfully',
              type:'success',
              confirmButtonText: 'OK'
            }).then(() => {
              this.resetForm();
              this.$router.push({ name: 'manage-standing-orders' });
            });
            
          }
        }).catch((error) => {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error'
          });
        });
      },
      goBackTo() {
        this.step--;
        this.form.transactionPin = null;
      },
      resetForm() {
        this.form.accountNumber = null;
        this.form.destinationAccountNumber = null;
        this.form.destinationAccountName = null;
        this.form.destinationBankCode = null;
        this.form.destinationBankName = null;
        this.form.amount = '0.00';
        this.form.description = null;
        this.form.frequency = null;
        this.form.customNumberOfDays = null;
        this.form.numberOfOccurence = null;
        this.form.startDate = null;
      },
    },
  };
</script>
<style scoped>
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
div >>> .calendar-input {
  width: 100% !important;
}
.vdp-datepicker {
  width: 335px !important;
}
@media screen and (max-width: 768px) {
  .vdp-datepicker {
    width: 275px !important;
  }
}
.col-form-label {
  color: #000;
}
.beneModal {
  background-color: transparent;
  border: none;
  margin-bottom: 0;
}
.ms-2 {
  margin-bottom: 0;
}
</style>